<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Roboto:500&display=swap');

  .abcRioButton {
    width: 230px;
    height: 40px;
    background-color: #fff;
    background-image: none;
    color: #262626;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    position: relative;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    -webkit-border-radius: 1px;
    border-radius: 1px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
    transition: background-color .218s, border-color .218s, box-shadow .218s;
    -webkit-user-select: none;
    -webkit-appearance: none;
  }

  .abcRioButtonBlue {
    background-color: #4285f4;
    border: none;
    color: #fff;

    .abcRioButtonContentWrapper {
      border: 1px solid transparent;
    }

    .abcRioButtonIcon {
      background-color: #fff;
      -webkit-border-radius: 1px;
      border-radius: 1px;
    }
  }

  .abcRioButtonContentWrapper {
    width: 100%;
    height: 100%;
  }

  .abcRioButtonIcon {
    float: left;
    padding: 10px;

    .abcRioButtonIconImage {
      width: 18px;
      height: 18px;
    }
  }

  .abcRioButtonSvg {
    display: block;
  }

  .abcRioButtonContents {
    font-family: Roboto, arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: .21px;
    vertical-align: top;
    line-height: 40px;
    margin-left: 14px;
    margin-right: 12px;
  }
</style>

<template>
  <div
    class="abcRioButton abcRioButtonBlue"
    @click.prevent="redirect"
  >
    <div class="abcRioButtonContentWrapper">
      <div class="abcRioButtonIcon">
        <div class="abcRioButtonIconImage">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="18px"
            height="18px"
            viewBox="0 0 48 48"
            class="abcRioButtonSvg"
          >
            <g>
              <path
                fill="#EA4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              />
              <path
                fill="#4285F4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              />
              <path
                fill="#FBBC05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              />
              <path
                fill="#34A853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              />
              <path
                fill="none"
                d="M0 0h48v48H0z"
              />
            </g>
          </svg>
        </div>
      </div>
      <span class="abcRioButtonContents">{{ __('Fazer login com o Google') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirect () {
      window.location = '/integration/google';
    },
  },
};
</script>
